/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];


export const OrganizationStatus = {
  pending: 'pending',
  active: 'active',
  suspended: 'suspended',
} as const;
